// Türkiye resmi Vergi Daireleri — GİB İVD verisinden derlenmiştir (yemreeke/vergi_daireleri, 1046 kayıt).
// n: daire adı, c: il, d: ilçe. Aranabilir açılır liste (TaxOfficeSelect) tarafından kullanılır.
export const TAX_OFFICES = [
  {"n": "5 Ocak Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Merkez"},
  {"n": "Adana İhtisas Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Merkez"},
  {"n": "Aladağ Malmüdürlüğü", "c": "ADANA", "d": "Aladağ"},
  {"n": "Ceyhan Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Ceyhan"},
  {"n": "Feke Malmüdürlüğü", "c": "ADANA", "d": "Feke"},
  {"n": "Karaisalı Malmüdürlüğü", "c": "ADANA", "d": "Karaisalı"},
  {"n": "Karataş Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Karataş"},
  {"n": "Kozan Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Kozan"},
  {"n": "Pozantı Malmüdürlüğü", "c": "ADANA", "d": "Pozantı"},
  {"n": "Saimbeyli Malmüdürlüğü", "c": "ADANA", "d": "Saimbeyli"},
  {"n": "Seyhan Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Merkez"},
  {"n": "Tufanbeyli Malmüdürlüğü", "c": "ADANA", "d": "Tufanbeyli"},
  {"n": "Yumurtalık Malmüdürlüğü", "c": "ADANA", "d": "Yumurtalık"},
  {"n": "Yüreğir Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Merkez"},
  {"n": "Ziyapaşa Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Merkez"},
  {"n": "Çukurova Vergi Dairesi Müdürlüğü", "c": "ADANA", "d": "Merkez"},
  {"n": "İmamoğlu Malmüdürlüğü", "c": "ADANA", "d": "İmamoğlu"},
  {"n": "Adıyaman Vergi Dairesi Müdürlüğü", "c": "ADIYAMAN", "d": "Merkez"},
  {"n": "Besni Malmüdürlüğü", "c": "ADIYAMAN", "d": "Besni"},
  {"n": "Gerger Malmüdürlüğü", "c": "ADIYAMAN", "d": "Gerger"},
  {"n": "Gölbaşı Malmüdürlüğü", "c": "ADIYAMAN", "d": "Gölbaşı"},
  {"n": "Kahta Vergi Dairesi Müdürlüğü", "c": "ADIYAMAN", "d": "Kahta"},
  {"n": "Samsat Malmüdürlüğü", "c": "ADIYAMAN", "d": "Samsat"},
  {"n": "Sincik Malmüdürlüğü", "c": "ADIYAMAN", "d": "Sincik"},
  {"n": "Tut Malmüdürlüğü", "c": "ADIYAMAN", "d": "Tut"},
  {"n": "Çelikhan Malmüdürlüğü", "c": "ADIYAMAN", "d": "Çelikhan"},
  {"n": "Bayat Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Bayat"},
  {"n": "Başmakçı Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Başmakçı"},
  {"n": "Bolvadin Vergi Dairesi Müdürlüğü", "c": "AFYONKARAHİSAR", "d": "Bolvadin"},
  {"n": "Dazkırı Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Dazkırı"},
  {"n": "Dinar Vergi Dairesi Müdürlüğü", "c": "AFYONKARAHİSAR", "d": "Dinar"},
  {"n": "Emirdağ Vergi Dairesi Müdürlüğü", "c": "AFYONKARAHİSAR", "d": "Emirdağ"},
  {"n": "Evciler Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Evciler"},
  {"n": "Hocalar Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Hocalar"},
  {"n": "Kocatepe Vergi Dairesi Müdürlüğü", "c": "AFYONKARAHİSAR", "d": "Merkez"},
  {"n": "Kızılören Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Kızılören"},
  {"n": "Sandıklı Vergi Dairesi Müdürlüğü", "c": "AFYONKARAHİSAR", "d": "Sandıklı"},
  {"n": "Sinanpaşa Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Sinanpaşa"},
  {"n": "Sultandağı Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Sultandağı"},
  {"n": "Tınaztepe Vergi Dairesi Müdürlüğü", "c": "AFYONKARAHİSAR", "d": "Merkez"},
  {"n": "Çay Vergi Dairesi Müdürlüğü", "c": "AFYONKARAHİSAR", "d": "Çay"},
  {"n": "Çobanlar Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Çobanlar"},
  {"n": "İhsaniye Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "İhsaniye"},
  {"n": "İscehisar Vergi Dairesi Müdürlüğü", "c": "AFYONKARAHİSAR", "d": "İscehisar"},
  {"n": "Şuhut Malmüdürlüğü", "c": "AFYONKARAHİSAR", "d": "Şuhut"},
  {"n": "Aksaray Vergi Dairesi Müdürlüğü", "c": "AKSARAY", "d": "Merkez"},
  {"n": "Ağaçören Malmüdürlüğü", "c": "AKSARAY", "d": "Ağaçören"},
  {"n": "Eskil Malmüdürlüğü", "c": "AKSARAY", "d": "Eskil"},
  {"n": "Gülağaç Malmüdürlüğü", "c": "AKSARAY", "d": "Gülağaç"},
  {"n": "Güzelyurt Malmüdürlüğü", "c": "AKSARAY", "d": "Güzelyurt"},
  {"n": "Ortaköy Malmüdürlüğü", "c": "AKSARAY", "d": "Ortaköy"},
  {"n": "Sarıyahşi Malmüdürlüğü", "c": "AKSARAY", "d": "Sarıyahşi"},
  {"n": "Sultanhanı Malmüdürlüğü", "c": "AKSARAY", "d": "Sultanhanı"},
  {"n": "Amasya Vergi Dairesi Müdürlüğü", "c": "AMASYA", "d": "Merkez"},
  {"n": "Göynücek Malmüdürlüğü", "c": "AMASYA", "d": "Göynücek"},
  {"n": "Gümüşhacıköy Vergi Dairesi Müdürlüğü", "c": "AMASYA", "d": "Gümüşhacıköy"},
  {"n": "Hamamözü Malmüdürlüğü", "c": "AMASYA", "d": "Hamamözü"},
  {"n": "Merzifon Vergi Dairesi Müdürlüğü", "c": "AMASYA", "d": "Merzifon"},
  {"n": "Suluova Vergi Dairesi Müdürlüğü", "c": "AMASYA", "d": "Suluova"},
  {"n": "Taşova Vergi Dairesi Müdürlüğü", "c": "AMASYA", "d": "Taşova"},
  {"n": "Akyurt Malmüdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Anadolu İhtisas Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Ankara Kurumlar Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Ankara İhtisas Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Ayaş Malmüdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Balâ Malmüdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Başkent Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Beypazarı Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Beypazarı"},
  {"n": "Cumhuriyet Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Dikimevi Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Doğanbey Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Dışkapı Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Elmadağ Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Etimesgut Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Evren Malmüdürlüğü", "c": "ANKARA", "d": "Evren"},
  {"n": "Gölbaşı Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Güdül Malmüdürlüğü", "c": "ANKARA", "d": "Güdül"},
  {"n": "Harçlar Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Haymana Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Haymana"},
  {"n": "Hitit Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Kahramankazan Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Kalecik Malmüdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Kavaklıdere Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Keçiören Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Kızılbey Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Kızılcahamam Malmüdürlüğü", "c": "ANKARA", "d": "Kızılcahamam"},
  {"n": "Maltepe Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Mithatpaşa Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Muhammet Karagüzel Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Nallıhan Malmüdürlüğü", "c": "ANKARA", "d": "Nallıhan"},
  {"n": "Ostim Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Polatlı Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Polatlı"},
  {"n": "Seğmenler Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Sincan Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Ulus Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Veraset ve İntikal Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Yahya Galip Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Yenimahalle Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Yeğenbey Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Yıldırım Beyazıt Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Çamlıdere Malmüdürlüğü", "c": "ANKARA", "d": "Çamlıdere"},
  {"n": "Çankaya Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Çubuk Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "İvedik Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Merkez"},
  {"n": "Şereflikoçhisar Vergi Dairesi Müdürlüğü", "c": "ANKARA", "d": "Şereflikoçhisar"},
  {"n": "Akseki Malmüdürlüğü", "c": "ANTALYA", "d": "Akseki"},
  {"n": "Alanya Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Alanya"},
  {"n": "Antalya Kurumlar Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Merkez"},
  {"n": "Antalya İhtisas Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Merkez"},
  {"n": "Demre Malmüdürlüğü", "c": "ANTALYA", "d": "Demre"},
  {"n": "Düden Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Merkez"},
  {"n": "Elmalı Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Elmalı"},
  {"n": "Finike Malmüdürlüğü", "c": "ANTALYA", "d": "Finike"},
  {"n": "Gazipaşa Malmüdürlüğü", "c": "ANTALYA", "d": "Gazipaşa"},
  {"n": "Gündoğmuş Malmüdürlüğü", "c": "ANTALYA", "d": "Gündoğmuş"},
  {"n": "Kalekapı Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Merkez"},
  {"n": "Kaş Malmüdürlüğü", "c": "ANTALYA", "d": "Kaş"},
  {"n": "Kemer Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Kemer"},
  {"n": "Korkuteli Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Korkuteli"},
  {"n": "Kumluca Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Kumluca"},
  {"n": "Manavgat Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Manavgat"},
  {"n": "Muratpaşa Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Merkez"},
  {"n": "Serik Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Serik"},
  {"n": "Üçkapılar Vergi Dairesi Müdürlüğü", "c": "ANTALYA", "d": "Merkez"},
  {"n": "İbradı Malmüdürlüğü", "c": "ANTALYA", "d": "İbradı"},
  {"n": "Ardahan Vergi Dairesi Müdürlüğü", "c": "ARDAHAN", "d": "Merkez"},
  {"n": "Damal Malmüdürlüğü", "c": "ARDAHAN", "d": "Damal"},
  {"n": "Göle Malmüdürlüğü", "c": "ARDAHAN", "d": "Göle"},
  {"n": "Hanak Malmüdürlüğü", "c": "ARDAHAN", "d": "Hanak"},
  {"n": "Posof Malmüdürlüğü", "c": "ARDAHAN", "d": "Posof"},
  {"n": "Çıldır Malmüdürlüğü", "c": "ARDAHAN", "d": "Çıldır"},
  {"n": "Ardanuç Malmüdürlüğü", "c": "ARTVİN", "d": "Ardanuç"},
  {"n": "Arhavi Vergi Dairesi Müdürlüğü", "c": "ARTVİN", "d": "Arhavi"},
  {"n": "Artvin Vergi Dairesi Müdürlüğü", "c": "ARTVİN", "d": "Merkez"},
  {"n": "Borçka Malmüdürlüğü", "c": "ARTVİN", "d": "Borçka"},
  {"n": "Hopa Vergi Dairesi Müdürlüğü", "c": "ARTVİN", "d": "Hopa"},
  {"n": "Murgul Malmüdürlüğü", "c": "ARTVİN", "d": "Murgul"},
  {"n": "Yusufeli Malmüdürlüğü", "c": "ARTVİN", "d": "Yusufeli"},
  {"n": "Şavşat Malmüdürlüğü", "c": "ARTVİN", "d": "Şavşat"},
  {"n": "Bozdoğan Malmüdürlüğü", "c": "AYDIN", "d": "Bozdoğan"},
  {"n": "Buharkent Malmüdürlüğü", "c": "AYDIN", "d": "Buharkent"},
  {"n": "Didim Vergi Dairesi Müdürlüğü", "c": "AYDIN", "d": "Didim"},
  {"n": "Efeler Vergi Dairesi Müdürlüğü", "c": "AYDIN", "d": "Merkez"},
  {"n": "Germencik Vergi Dairesi Müdürlüğü", "c": "AYDIN", "d": "Germencik"},
  {"n": "Güzelhisar Vergi Dairesi Müdürlüğü", "c": "AYDIN", "d": "Merkez"},
  {"n": "Karacasu Malmüdürlüğü", "c": "AYDIN", "d": "Karacasu"},
  {"n": "Karpuzlu Malmüdürlüğü", "c": "AYDIN", "d": "Karpuzlu"},
  {"n": "Koçarlı Malmüdürlüğü", "c": "AYDIN", "d": "Koçarlı"},
  {"n": "Kuyucak Malmüdürlüğü", "c": "AYDIN", "d": "Kuyucak"},
  {"n": "Kuşadası Vergi Dairesi Müdürlüğü", "c": "AYDIN", "d": "Kuşadası"},
  {"n": "Köşk Malmüdürlüğü", "c": "AYDIN", "d": "Köşk"},
  {"n": "Nazilli Vergi Dairesi Müdürlüğü", "c": "AYDIN", "d": "Nazilli"},
  {"n": "Sultanhisar Malmüdürlüğü", "c": "AYDIN", "d": "Sultanhisar"},
  {"n": "Söke Vergi Dairesi Müdürlüğü", "c": "AYDIN", "d": "Söke"},
  {"n": "Yenipazar Malmüdürlüğü", "c": "AYDIN", "d": "Yenipazar"},
  {"n": "Çine Vergi Dairesi Müdürlüğü", "c": "AYDIN", "d": "Çine"},
  {"n": "İncirliova Malmüdürlüğü", "c": "AYDIN", "d": "İncirliova"},
  {"n": "Ağrı Vergi Dairesi Müdürlüğü", "c": "AĞRI", "d": "Merkez"},
  {"n": "Diyadin Malmüdürlüğü", "c": "AĞRI", "d": "Diyadin"},
  {"n": "Doğubeyazıt Vergi Dairesi Müdürlüğü", "c": "AĞRI", "d": "Doğubeyazıt"},
  {"n": "Eleşkirt Malmüdürlüğü", "c": "AĞRI", "d": "Eleşkirt"},
  {"n": "Hamur Malmüdürlüğü", "c": "AĞRI", "d": "Hamur"},
  {"n": "Patnos Vergi Dairesi Müdürlüğü", "c": "AĞRI", "d": "Patnos"},
  {"n": "Taşlıçay Malmüdürlüğü", "c": "AĞRI", "d": "Taşlıçay"},
  {"n": "Tutak Malmüdürlüğü", "c": "AĞRI", "d": "Tutak"},
  {"n": "Ayvalık Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Ayvalık"},
  {"n": "Balya Malmüdürlüğü", "c": "BALIKESİR", "d": "Balya"},
  {"n": "Bandırma Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Bandırma"},
  {"n": "Bigadiç Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Bigadiç"},
  {"n": "Burhaniye Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Burhaniye"},
  {"n": "Dursunbey Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Dursunbey"},
  {"n": "Edremit Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Edremit"},
  {"n": "Erdek Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Erdek"},
  {"n": "Gömeç Malmüdürlüğü", "c": "BALIKESİR", "d": "Gömeç"},
  {"n": "Gönen Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Gönen"},
  {"n": "Havran Malmüdürlüğü", "c": "BALIKESİR", "d": "Havran"},
  {"n": "Karesi Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Merkez"},
  {"n": "Kepsut Malmüdürlüğü", "c": "BALIKESİR", "d": "Kepsut"},
  {"n": "Kurtdereli Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Merkez"},
  {"n": "Manyas Malmüdürlüğü", "c": "BALIKESİR", "d": "Manyas"},
  {"n": "Marmara Malmüdürlüğü", "c": "BALIKESİR", "d": "Marmara"},
  {"n": "Savaştepe Malmüdürlüğü", "c": "BALIKESİR", "d": "Savaştepe"},
  {"n": "Susurluk Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Susurluk"},
  {"n": "Sındırgı Vergi Dairesi Müdürlüğü", "c": "BALIKESİR", "d": "Sındırgı"},
  {"n": "İvrindi Malmüdürlüğü", "c": "BALIKESİR", "d": "İvrindi"},
  {"n": "Amasra Malmüdürlüğü", "c": "BARTIN", "d": "Amasra"},
  {"n": "Bartın Vergi Dairesi Müdürlüğü", "c": "BARTIN", "d": "Merkez"},
  {"n": "Kurucaşile Malmüdürlüğü", "c": "BARTIN", "d": "Kurucaşile"},
  {"n": "Ulus Malmüdürlüğü", "c": "BARTIN", "d": "Ulus"},
  {"n": "Batman Vergi Dairesi Müdürlüğü", "c": "BATMAN", "d": "Merkez"},
  {"n": "Beşiri Malmüdürlüğü", "c": "BATMAN", "d": "Beşiri"},
  {"n": "Gercüş Malmüdürlüğü", "c": "BATMAN", "d": "Gercüş"},
  {"n": "Hasankeyf Malmüdürlüğü", "c": "BATMAN", "d": "Hasankeyf"},
  {"n": "Kozluk Malmüdürlüğü", "c": "BATMAN", "d": "Kozluk"},
  {"n": "Sason Malmüdürlüğü", "c": "BATMAN", "d": "Sason"},
  {"n": "Aydıntepe Malmüdürlüğü", "c": "BAYBURT", "d": "Aydıntepe"},
  {"n": "Bayburt Vergi Dairesi Müdürlüğü", "c": "BAYBURT", "d": "Merkez"},
  {"n": "Demirözü Malmüdürlüğü", "c": "BAYBURT", "d": "Demirözü"},
  {"n": "Bolu Vergi Dairesi Müdürlüğü", "c": "BOLU", "d": "Merkez"},
  {"n": "Dörtdivan Malmüdürlüğü", "c": "BOLU", "d": "Dörtdivan"},
  {"n": "Gerede Vergi Dairesi Müdürlüğü", "c": "BOLU", "d": "Gerede"},
  {"n": "Göynük Malmüdürlüğü", "c": "BOLU", "d": "Göynük"},
  {"n": "Kıbrıscık Malmüdürlüğü", "c": "BOLU", "d": "Kıbrıscık"},
  {"n": "Mengen Malmüdürlüğü", "c": "BOLU", "d": "Mengen"},
  {"n": "Mudurnu Malmüdürlüğü", "c": "BOLU", "d": "Mudurnu"},
  {"n": "Seben Malmüdürlüğü", "c": "BOLU", "d": "Seben"},
  {"n": "Yeniçağa Malmüdürlüğü", "c": "BOLU", "d": "Yeniçağa"},
  {"n": "Altınyayla Malmüdürlüğü", "c": "BURDUR", "d": "Altınyayla"},
  {"n": "Ağlasun Malmüdürlüğü", "c": "BURDUR", "d": "Ağlasun"},
  {"n": "Bucak Vergi Dairesi Müdürlüğü", "c": "BURDUR", "d": "Bucak"},
  {"n": "Burdur Vergi Dairesi Müdürlüğü", "c": "BURDUR", "d": "Merkez"},
  {"n": "Gölhisar Malmüdürlüğü", "c": "BURDUR", "d": "Gölhisar"},
  {"n": "Karamanlı Malmüdürlüğü", "c": "BURDUR", "d": "Karamanlı"},
  {"n": "Kemer Malmüdürlüğü", "c": "BURDUR", "d": "Kemer"},
  {"n": "Tefenni Malmüdürlüğü", "c": "BURDUR", "d": "Tefenni"},
  {"n": "Yeşilova Malmüdürlüğü", "c": "BURDUR", "d": "Yeşilova"},
  {"n": "Çavdır Malmüdürlüğü", "c": "BURDUR", "d": "Çavdır"},
  {"n": "Çeltikçi Malmüdürlüğü", "c": "BURDUR", "d": "Çeltikçi"},
  {"n": "Bursa Veraset ve Harçlar Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Bursa İhtisas Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Büyükorhan Malmüdürlüğü", "c": "BURSA", "d": "Büyükorhan"},
  {"n": "Ertuğrulgazi Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Gemlik Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Gökdere Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Harmancık Malmüdürlüğü", "c": "BURSA", "d": "Harmancık"},
  {"n": "Karacabey Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Karacabey"},
  {"n": "Keles Malmüdürlüğü", "c": "BURSA", "d": "Keles"},
  {"n": "Mudanya Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Mustafakemalpaşa Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Mustafakemalpaşa"},
  {"n": "Nilüfer Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Orhaneli Malmüdürlüğü", "c": "BURSA", "d": "Orhaneli"},
  {"n": "Orhangazi Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Orhangazi"},
  {"n": "Osmangazi Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Setbaşı Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Uludağ Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Yenişehir Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Yenişehir"},
  {"n": "Yeşil Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Yıldırım Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "Çekirge Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "Merkez"},
  {"n": "İnegöl Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "İnegöl"},
  {"n": "İznik Vergi Dairesi Müdürlüğü", "c": "BURSA", "d": "İznik"},
  {"n": "Bilecik Vergi Dairesi Müdürlüğü", "c": "BİLECİK", "d": "Merkez"},
  {"n": "Bozüyük Vergi Dairesi Müdürlüğü", "c": "BİLECİK", "d": "Bozüyük"},
  {"n": "Gölpazarı Malmüdürlüğü", "c": "BİLECİK", "d": "Gölpazarı"},
  {"n": "Osmaneli Malmüdürlüğü", "c": "BİLECİK", "d": "Osmaneli"},
  {"n": "Pazaryeri Malmüdürlüğü", "c": "BİLECİK", "d": "Pazaryeri"},
  {"n": "Söğüt Malmüdürlüğü", "c": "BİLECİK", "d": "Söğüt"},
  {"n": "Yenipazar Malmüdürlüğü", "c": "BİLECİK", "d": "Yenipazar"},
  {"n": "İnhisar Malmüdürlüğü", "c": "BİLECİK", "d": "İnhisar"},
  {"n": "Adaklı Malmüdürlüğü", "c": "BİNGÖL", "d": "Adaklı"},
  {"n": "Bingöl Vergi Dairesi Müdürlüğü", "c": "BİNGÖL", "d": "Merkez"},
  {"n": "Genç Malmüdürlüğü", "c": "BİNGÖL", "d": "Genç"},
  {"n": "Karlıova Malmüdürlüğü", "c": "BİNGÖL", "d": "Karlıova"},
  {"n": "Kiğı Malmüdürlüğü", "c": "BİNGÖL", "d": "Kiğı"},
  {"n": "Solhan Malmüdürlüğü", "c": "BİNGÖL", "d": "Solhan"},
  {"n": "Yayladere Malmüdürlüğü", "c": "BİNGÖL", "d": "Yayladere"},
  {"n": "Yedisu Malmüdürlüğü", "c": "BİNGÖL", "d": "Yedisu"},
  {"n": "Adilcevaz Malmüdürlüğü", "c": "BİTLİS", "d": "Adilcevaz"},
  {"n": "Ahlat Malmüdürlüğü", "c": "BİTLİS", "d": "Ahlat"},
  {"n": "Bitlis Vergi Dairesi Müdürlüğü", "c": "BİTLİS", "d": "Merkez"},
  {"n": "Güroymak Malmüdürlüğü", "c": "BİTLİS", "d": "Göroymak"},
  {"n": "Hizan Malmüdürlüğü", "c": "BİTLİS", "d": "Hizan"},
  {"n": "Mutki Malmüdürlüğü", "c": "BİTLİS", "d": "Mutki"},
  {"n": "Tatvan Vergi Dairesi Müdürlüğü", "c": "BİTLİS", "d": "Tatvan"},
  {"n": "Acıpayam Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Acıpayam"},
  {"n": "Babadağ Malmüdürlüğü", "c": "DENİZLİ", "d": "Babadağ"},
  {"n": "Baklan Malmüdürlüğü", "c": "DENİZLİ", "d": "Baklan"},
  {"n": "Bekilli Malmüdürlüğü", "c": "DENİZLİ", "d": "Bekilli"},
  {"n": "Beyağaç Malmüdürlüğü", "c": "DENİZLİ", "d": "Beyağaç"},
  {"n": "Bozkurt Malmüdürlüğü", "c": "DENİZLİ", "d": "Bozkurt"},
  {"n": "Buldan Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Buldan"},
  {"n": "Denizli İhtisas Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Merkez"},
  {"n": "Gökpınar Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Merkez"},
  {"n": "Güney Malmüdürlüğü", "c": "DENİZLİ", "d": "Güney"},
  {"n": "Honaz Malmüdürlüğü", "c": "DENİZLİ", "d": "Honaz"},
  {"n": "Kale Malmüdürlüğü", "c": "DENİZLİ", "d": "Kale"},
  {"n": "Pamukkale Malmüdürlüğü (Akköy)", "c": "DENİZLİ", "d": "Pamukkale"},
  {"n": "Pamukkale Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Merkez"},
  {"n": "Sarayköy Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Sarayköy"},
  {"n": "Saraylar Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Merkez"},
  {"n": "Serinhisar Malmüdürlüğü", "c": "DENİZLİ", "d": "Serinhisar"},
  {"n": "Tavas Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Tavas"},
  {"n": "Çal Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Çal"},
  {"n": "Çameli Malmüdürlüğü", "c": "DENİZLİ", "d": "Çameli"},
  {"n": "Çardak Malmüdürlüğü", "c": "DENİZLİ", "d": "Çardak"},
  {"n": "Çivril Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Çivril"},
  {"n": "Çınar Vergi Dairesi Müdürlüğü", "c": "DENİZLİ", "d": "Merkez"},
  {"n": "Akçakoca Vergi Dairesi Müdürlüğü", "c": "DÜZCE", "d": "Akçakoca"},
  {"n": "Cumayeri Malmüdürlüğü", "c": "DÜZCE", "d": "Cumayeri"},
  {"n": "Düzce Vergi Dairesi Müdürlüğü", "c": "DÜZCE", "d": "Merkez"},
  {"n": "Gölyaka Malmüdürlüğü", "c": "DÜZCE", "d": "Gölyaka"},
  {"n": "Gümüşova Malmüdürlüğü", "c": "DÜZCE", "d": "Gümüşova"},
  {"n": "Kaynaşlı Malmüdürlüğü", "c": "DÜZCE", "d": "Kaynaşlı"},
  {"n": "Yığılca Malmüdürlüğü", "c": "DÜZCE", "d": "Yığılca"},
  {"n": "Çilimli Malmüdürlüğü", "c": "DÜZCE", "d": "Çilimli"},
  {"n": "Bismil Vergi Dairesi Müdürlüğü", "c": "DİYARBAKIR", "d": "Bismil"},
  {"n": "Cahit Sıtkı Tarancı Vergi Dairesi Müdürlüğü", "c": "DİYARBAKIR", "d": "Merkez"},
  {"n": "Dicle Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Dicle"},
  {"n": "Ergani Vergi Dairesi Müdürlüğü", "c": "DİYARBAKIR", "d": "Ergani"},
  {"n": "Eğil Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Eğil"},
  {"n": "Gökalp Vergi Dairesi Müdürlüğü", "c": "DİYARBAKIR", "d": "Merkez"},
  {"n": "Hani Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Hani"},
  {"n": "Hazro Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Hazro"},
  {"n": "Kocaköy Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Kocaköy"},
  {"n": "Kulp Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Kulp"},
  {"n": "Lice Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Lice"},
  {"n": "Silvan Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Silvan"},
  {"n": "Süleyman Nazif Vergi Dairesi Müdürlüğü", "c": "DİYARBAKIR", "d": "Merkez"},
  {"n": "Çermik Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Çermik"},
  {"n": "Çüngüş Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Çüngüş"},
  {"n": "Çınar Malmüdürlüğü", "c": "DİYARBAKIR", "d": "Çınar"},
  {"n": "Arda Vergi Dairesi Müdürlüğü", "c": "EDİRNE", "d": "Merkez"},
  {"n": "Enez Malmüdürlüğü", "c": "EDİRNE", "d": "Enez"},
  {"n": "Havsa Vergi Dairesi Müdürlüğü", "c": "EDİRNE", "d": "Havsa"},
  {"n": "Keşan Vergi Dairesi Müdürlüğü", "c": "EDİRNE", "d": "Keşan"},
  {"n": "Kırkpınar Vergi Dairesi Müdürlüğü", "c": "EDİRNE", "d": "Merkez"},
  {"n": "Lalapaşa Malmüdürlüğü", "c": "EDİRNE", "d": "Lalapaşa"},
  {"n": "Meriç Malmüdürlüğü", "c": "EDİRNE", "d": "Meriç"},
  {"n": "Süloğlu Malmüdürlüğü", "c": "EDİRNE", "d": "Süloğlu"},
  {"n": "Uzunköprü Vergi Dairesi Müdürlüğü", "c": "EDİRNE", "d": "Uzunköprü"},
  {"n": "İpsala Vergi Dairesi Müdürlüğü", "c": "EDİRNE", "d": "İpsala"},
  {"n": "Alacakaya Malmüdürlüğü", "c": "ELAZIĞ", "d": "Alacakaya"},
  {"n": "Arıcak Malmüdürlüğü", "c": "ELAZIĞ", "d": "Arıcak"},
  {"n": "Ağın Malmüdürlüğü", "c": "ELAZIĞ", "d": "Ağın"},
  {"n": "Baskil Malmüdürlüğü", "c": "ELAZIĞ", "d": "Baskil"},
  {"n": "Harput Vergi Dairesi Müdürlüğü", "c": "ELAZIĞ", "d": "Merkez"},
  {"n": "Hazar Vergi Dairesi Müdürlüğü", "c": "ELAZIĞ", "d": "Merkez"},
  {"n": "Karakoçan Malmüdürlüğü", "c": "ELAZIĞ", "d": "Karakoçan"},
  {"n": "Keban Malmüdürlüğü", "c": "ELAZIĞ", "d": "Keban"},
  {"n": "Kovancılar Malmüdürlüğü", "c": "ELAZIĞ", "d": "Kovancılar"},
  {"n": "Maden Malmüdürlüğü", "c": "ELAZIĞ", "d": "Maden"},
  {"n": "Palu Malmüdürlüğü", "c": "ELAZIĞ", "d": "Palu"},
  {"n": "Sivrice Malmüdürlüğü", "c": "ELAZIĞ", "d": "Sivrice"},
  {"n": "Aziziye Malmüdürlüğü (Ilıca)", "c": "ERZURUM", "d": "Merkez"},
  {"n": "Aziziye Vergi Dairesi Müdürlüğü", "c": "ERZURUM", "d": "Merkez"},
  {"n": "Aşkale Malmüdürlüğü", "c": "ERZURUM", "d": "Aşkale"},
  {"n": "Horasan Malmüdürlüğü", "c": "ERZURUM", "d": "Horasan"},
  {"n": "Hınıs Malmüdürlüğü", "c": "ERZURUM", "d": "Hınıs"},
  {"n": "Karayazı Malmüdürlüğü", "c": "ERZURUM", "d": "Karayazı"},
  {"n": "Karaçoban Malmüdürlüğü", "c": "ERZURUM", "d": "Karaçoban"},
  {"n": "Kazımkarabekir Vergi Dairesi Müdürlüğü", "c": "ERZURUM", "d": "Merkez"},
  {"n": "Köprüköy Malmüdürlüğü", "c": "ERZURUM", "d": "Köprüköy"},
  {"n": "Narman Malmüdürlüğü", "c": "ERZURUM", "d": "Narman"},
  {"n": "Oltu Malmüdürlüğü", "c": "ERZURUM", "d": "Oltu"},
  {"n": "Olur Malmüdürlüğü", "c": "ERZURUM", "d": "Olur"},
  {"n": "Pasinler Malmüdürlüğü", "c": "ERZURUM", "d": "Pasinler"},
  {"n": "Pazaryolu Malmüdürlüğü", "c": "ERZURUM", "d": "Pazaryolu"},
  {"n": "Tekman Malmüdürlüğü", "c": "ERZURUM", "d": "Tekman"},
  {"n": "Tortum Malmüdürlüğü", "c": "ERZURUM", "d": "Tortum"},
  {"n": "Uzundere Malmüdürlüğü", "c": "ERZURUM", "d": "Uzundere"},
  {"n": "Çat Malmüdürlüğü", "c": "ERZURUM", "d": "Çat"},
  {"n": "İspir Malmüdürlüğü", "c": "ERZURUM", "d": "İspir"},
  {"n": "Şenkaya Malmüdürlüğü", "c": "ERZURUM", "d": "Şenkaya"},
  {"n": "Fevzipaşa Vergi Dairesi Müdürlüğü", "c": "ERZİNCAN", "d": "Merkez"},
  {"n": "Kemah Malmüdürlüğü", "c": "ERZİNCAN", "d": "Kemah"},
  {"n": "Kemaliye Malmüdürlüğü", "c": "ERZİNCAN", "d": "Kemaliye"},
  {"n": "Otlukbeli Malmüdürlüğü", "c": "ERZİNCAN", "d": "Otlukbeli"},
  {"n": "Refahiye Malmüdürlüğü", "c": "ERZİNCAN", "d": "Refahiye"},
  {"n": "Tercan Malmüdürlüğü", "c": "ERZİNCAN", "d": "Tercan"},
  {"n": "Çayırlı Malmüdürlüğü", "c": "ERZİNCAN", "d": "Çayırlı"},
  {"n": "Üzümlü Malmüdürlüğü", "c": "ERZİNCAN", "d": "Üzümlü"},
  {"n": "İliç Malmüdürlüğü", "c": "ERZİNCAN", "d": "İliç"},
  {"n": "Alpu Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Alpu"},
  {"n": "Beylikova Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Beylikova"},
  {"n": "Eskişehir Vergi Dairesi Başkanlığı (*)", "c": "ESKİŞEHİR", "d": "Merkez Başkanlık"},
  {"n": "Günyüzü Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Günyüzü"},
  {"n": "Han Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Han"},
  {"n": "Mahmudiye Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Mahmudiye"},
  {"n": "Mihalgazi Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Mihalgazi"},
  {"n": "Mihalıççık Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Mihalıççık"},
  {"n": "Sarıcakaya Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Sarıcakaya"},
  {"n": "Seyitgazi Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "Seyitgazi"},
  {"n": "İnönü Malmüdürlüğü", "c": "ESKİŞEHİR", "d": "İnönü"},
  {"n": "Araban Malmüdürlüğü", "c": "GAZİANTEP", "d": "Araban"},
  {"n": "Gaziantep İhtisas Vergi Dairesi Müdürlüğü", "c": "GAZİANTEP", "d": "Merkez"},
  {"n": "Gazikent Vergi Dairesi Müdürlüğü", "c": "GAZİANTEP", "d": "Merkez"},
  {"n": "Karkamış Malmüdürlüğü", "c": "GAZİANTEP", "d": "Karkamış"},
  {"n": "Kozanlı Vergi Dairesi Müdürlüğü", "c": "GAZİANTEP", "d": "Merkez"},
  {"n": "Nizip Vergi Dairesi Müdürlüğü", "c": "GAZİANTEP", "d": "Nizip"},
  {"n": "Nurdağı Malmüdürlüğü", "c": "GAZİANTEP", "d": "Nurdağı"},
  {"n": "Oğuzeli Malmüdürlüğü", "c": "GAZİANTEP", "d": "Merkez"},
  {"n": "Suburcu Vergi Dairesi Müdürlüğü", "c": "GAZİANTEP", "d": "Merkez"},
  {"n": "Yavuzeli Malmüdürlüğü", "c": "GAZİANTEP", "d": "Yavuzeli"},
  {"n": "İslahiye Vergi Dairesi Müdürlüğü", "c": "GAZİANTEP", "d": "İslahiye"},
  {"n": "Şahinbey Vergi Dairesi Müdürlüğü", "c": "GAZİANTEP", "d": "Merkez"},
  {"n": "Şehitkâmil Vergi Dairesi Müdürlüğü", "c": "GAZİANTEP", "d": "Merkez"},
  {"n": "Gümüşhane Vergi Dairesi Müdürlüğü", "c": "GÜMÜŞHANE", "d": "Merkez"},
  {"n": "Kelkit Malmüdürlüğü", "c": "GÜMÜŞHANE", "d": "Kelkit"},
  {"n": "Köse Malmüdürlüğü", "c": "GÜMÜŞHANE", "d": "Köse"},
  {"n": "Kürtün Malmüdürlüğü", "c": "GÜMÜŞHANE", "d": "Kürtün"},
  {"n": "Torul Malmüdürlüğü", "c": "GÜMÜŞHANE", "d": "Torul"},
  {"n": "Şiran Malmüdürlüğü", "c": "GÜMÜŞHANE", "d": "Şiran"},
  {"n": "Alucra Malmüdürlüğü", "c": "GİRESUN", "d": "Alucra"},
  {"n": "Bulancak Vergi Dairesi Müdürlüğü", "c": "GİRESUN", "d": "Bulancak"},
  {"n": "Dereli Malmüdürlüğü", "c": "GİRESUN", "d": "Dereli"},
  {"n": "Doğankent Malmüdürlüğü", "c": "GİRESUN", "d": "Doğankent"},
  {"n": "Espiye Malmüdürlüğü", "c": "GİRESUN", "d": "Espiye"},
  {"n": "Eynesil Malmüdürlüğü", "c": "GİRESUN", "d": "Eynesil"},
  {"n": "Giresun Vergi Dairesi Müdürlüğü", "c": "GİRESUN", "d": "Merkez"},
  {"n": "Görele Malmüdürlüğü", "c": "GİRESUN", "d": "Görele"},
  {"n": "Güce Malmüdürlüğü", "c": "GİRESUN", "d": "Güce"},
  {"n": "Keşap Malmüdürlüğü", "c": "GİRESUN", "d": "Keşap"},
  {"n": "Piraziz Malmüdürlüğü", "c": "GİRESUN", "d": "Piraziz"},
  {"n": "Tirebolu Malmüdürlüğü", "c": "GİRESUN", "d": "Tirebolu"},
  {"n": "Yağlıdere Malmüdürlüğü", "c": "GİRESUN", "d": "Yağlıdere"},
  {"n": "Çamoluk Malmüdürlüğü", "c": "GİRESUN", "d": "Çamoluk"},
  {"n": "Çanakçı Malmüdürlüğü", "c": "GİRESUN", "d": "Çanakçı"},
  {"n": "Şebinkarahisar Malmüdürlüğü", "c": "GİRESUN", "d": "Şebinkarahisar"},
  {"n": "Derecik Malmüdürlüğü", "c": "HAKKARİ", "d": "Derecik"},
  {"n": "Hakkari Vergi Dairesi Müdürlüğü", "c": "HAKKARİ", "d": "Merkez"},
  {"n": "Yüksekova Vergi Dairesi Müdürlüğü", "c": "HAKKARİ", "d": "Yüksekova"},
  {"n": "Çukurca Malmüdürlüğü", "c": "HAKKARİ", "d": "Çukurca"},
  {"n": "Şemdinli Malmüdürlüğü", "c": "HAKKARİ", "d": "Şemdinli"},
  {"n": "23 Temmuz Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "Merkez"},
  {"n": "Akdeniz Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "İskenderun"},
  {"n": "Altınözü Malmüdürlüğü", "c": "HATAY", "d": "Altınözü"},
  {"n": "Antakya Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "Merkez"},
  {"n": "Asım Gündüz Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "İskenderun"},
  {"n": "Belen Malmüdürlüğü", "c": "HATAY", "d": "Belen"},
  {"n": "Dörtyol Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "Dörtyol"},
  {"n": "Erzin Malmüdürlüğü", "c": "HATAY", "d": "Erzin"},
  {"n": "Hassa Malmüdürlüğü", "c": "HATAY", "d": "Hassa"},
  {"n": "Kumlu Malmüdürlüğü", "c": "HATAY", "d": "Kumlu"},
  {"n": "Kırıkhan Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "Kırıkhan"},
  {"n": "Reyhanlı Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "Reyhanlı"},
  {"n": "Sahil Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "İskenderun"},
  {"n": "Samandağ Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "Samandağ"},
  {"n": "Yayladağı Malmüdürlüğü", "c": "HATAY", "d": "Yayladağı"},
  {"n": "Şükrükanatlı Vergi Dairesi Müdürlüğü", "c": "HATAY", "d": "Merkez"},
  {"n": "Aksu Malmüdürlüğü", "c": "ISPARTA", "d": "Aksu"},
  {"n": "Atabey Malmüdürlüğü", "c": "ISPARTA", "d": "Atabey"},
  {"n": "Davraz Vergi Dairesi Müdürlüğü", "c": "ISPARTA", "d": "Merkez"},
  {"n": "Eğirdir Vergi Dairesi Müdürlüğü", "c": "ISPARTA", "d": "Eğirdir"},
  {"n": "Gelendost Malmüdürlüğü", "c": "ISPARTA", "d": "Gelendost"},
  {"n": "Gönen Malmüdürlüğü", "c": "ISPARTA", "d": "Gönen"},
  {"n": "Kaymakkapı Vergi Dairesi Müdürlüğü", "c": "ISPARTA", "d": "Merkez"},
  {"n": "Keçiborlu Malmüdürlüğü", "c": "ISPARTA", "d": "Keçiborlu"},
  {"n": "Senirkent Malmüdürlüğü", "c": "ISPARTA", "d": "Senirkent"},
  {"n": "Sütçüler Malmüdürlüğü", "c": "ISPARTA", "d": "Sütçüler"},
  {"n": "Uluborlu Malmüdürlüğü", "c": "ISPARTA", "d": "Uluborlu"},
  {"n": "Yalvaç Vergi Dairesi Müdürlüğü", "c": "ISPARTA", "d": "Yalvaç"},
  {"n": "Yenişarbademli Malmüdürlüğü", "c": "ISPARTA", "d": "Yenişarbademli"},
  {"n": "Şarkikaraağaç Malmüdürlüğü", "c": "ISPARTA", "d": "Şarkikaraağaç"},
  {"n": "Aralık Malmüdürlüğü", "c": "IĞDIR", "d": "Aralık"},
  {"n": "Iğdır Vergi Dairesi Müdürlüğü", "c": "IĞDIR", "d": "Merkez"},
  {"n": "Karakoyunlu Malmüdürlüğü", "c": "IĞDIR", "d": "Karakoyunlu"},
  {"n": "Tuzluca Malmüdürlüğü", "c": "IĞDIR", "d": "Tuzluca"},
  {"n": "Afşin Vergi Dairesi Müdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Afşin"},
  {"n": "Aksu Vergi Dairesi Müdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Merkez"},
  {"n": "Andırın Malmüdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Andırın"},
  {"n": "Aslanbey Vergi Dairesi Müdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Merkez"},
  {"n": "Ekinözü Malmüdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Ekinözü"},
  {"n": "Elbistan Vergi Dairesi Müdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Elbistan"},
  {"n": "Göksun Malmüdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Göksun"},
  {"n": "Nurhak Malmüdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Nurhak"},
  {"n": "Pazarcık Vergi Dairesi Müdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Pazarcık"},
  {"n": "Türkoğlu Malmüdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Türkoğlu"},
  {"n": "Çağlayancerit Malmüdürlüğü", "c": "KAHRAMANMARAŞ", "d": "Çağlayancerit"},
  {"n": "Eflani Malmüdürlüğü", "c": "KARABÜK", "d": "Eflani"},
  {"n": "Eskipazar Malmüdürlüğü", "c": "KARABÜK", "d": "Eskipazar"},
  {"n": "Karabük Vergi Dairesi Müdürlüğü", "c": "KARABÜK", "d": "Merkez"},
  {"n": "Ovacık Malmüdürlüğü", "c": "KARABÜK", "d": "Ovacık"},
  {"n": "Safranbolu Vergi Dairesi Müdürlüğü", "c": "KARABÜK", "d": "Safranbolu"},
  {"n": "Yenice Malmüdürlüğü", "c": "KARABÜK", "d": "Yenice"},
  {"n": "Ayrancı Malmüdürlüğü", "c": "KARAMAN", "d": "Ayrancı"},
  {"n": "Başyayla Malmüdürlüğü", "c": "KARAMAN", "d": "Başyayla"},
  {"n": "Ermenek Malmüdürlüğü", "c": "KARAMAN", "d": "Ermenek"},
  {"n": "Karaman Vergi Dairesi Müdürlüğü", "c": "KARAMAN", "d": "Merkez"},
  {"n": "Kazım Karabekir Malmüdürlüğü", "c": "KARAMAN", "d": "Kazım Karabekir"},
  {"n": "Sarıveliler Malmüdürlüğü", "c": "KARAMAN", "d": "Sarıveliler"},
  {"n": "Akyaka Malmüdürlüğü", "c": "KARS", "d": "Akyaka"},
  {"n": "Arpaçay Malmüdürlüğü", "c": "KARS", "d": "Arpaçay"},
  {"n": "Digor Malmüdürlüğü", "c": "KARS", "d": "Digor"},
  {"n": "Kars Vergi Dairesi Müdürlüğü", "c": "KARS", "d": "Merkez"},
  {"n": "Kağızman Malmüdürlüğü", "c": "KARS", "d": "Kağızman"},
  {"n": "Sarıkamış Malmüdürlüğü", "c": "KARS", "d": "Sarıkamış"},
  {"n": "Selim Malmüdürlüğü", "c": "KARS", "d": "Selim"},
  {"n": "Susuz Malmüdürlüğü", "c": "KARS", "d": "Susuz"},
  {"n": "Abana Malmüdürlüğü", "c": "KASTAMONU", "d": "Abana"},
  {"n": "Araç Malmüdürlüğü", "c": "KASTAMONU", "d": "Araç"},
  {"n": "Azdavay Malmüdürlüğü", "c": "KASTAMONU", "d": "Azdavay"},
  {"n": "Ağlı Malmüdürlüğü", "c": "KASTAMONU", "d": "Ağlı"},
  {"n": "Bozkurt Malmüdürlüğü", "c": "KASTAMONU", "d": "Bozkurt"},
  {"n": "Cide Malmüdürlüğü", "c": "KASTAMONU", "d": "Cide"},
  {"n": "Daday Malmüdürlüğü", "c": "KASTAMONU", "d": "Daday"},
  {"n": "Devrekani Malmüdürlüğü", "c": "KASTAMONU", "d": "Devrekani"},
  {"n": "Doğanyurt Malmüdürlüğü", "c": "KASTAMONU", "d": "Doğanyurt"},
  {"n": "Hanönü Malmüdürlüğü", "c": "KASTAMONU", "d": "Hanönü"},
  {"n": "Kastamonu Vergi Dairesi Müdürlüğü", "c": "KASTAMONU", "d": "Merkez"},
  {"n": "Küre Malmüdürlüğü", "c": "KASTAMONU", "d": "Küre"},
  {"n": "Pınarbaşı Malmüdürlüğü", "c": "KASTAMONU", "d": "Pınarbaşı"},
  {"n": "Seydiler Malmüdürlüğü", "c": "KASTAMONU", "d": "Seydiler"},
  {"n": "Taşköprü Vergi Dairesi Müdürlüğü", "c": "KASTAMONU", "d": "Taşköprü"},
  {"n": "Tosya Vergi Dairesi Müdürlüğü", "c": "KASTAMONU", "d": "Tosya"},
  {"n": "Çatalzeytin Malmüdürlüğü", "c": "KASTAMONU", "d": "Çatalzeytin"},
  {"n": "İhsangazi Malmüdürlüğü", "c": "KASTAMONU", "d": "İhsangazi"},
  {"n": "İnebolu Malmüdürlüğü", "c": "KASTAMONU", "d": "İnebolu"},
  {"n": "Şenpazar Malmüdürlüğü", "c": "KASTAMONU", "d": "Şenpazar"},
  {"n": "Akkışla Malmüdürlüğü", "c": "KAYSERİ", "d": "Akkışla"},
  {"n": "Bünyan Vergi Dairesi Müdürlüğü", "c": "KAYSERİ", "d": "Bünyan"},
  {"n": "Develi Vergi Dairesi Müdürlüğü", "c": "KAYSERİ", "d": "Develi"},
  {"n": "Erciyes Vergi Dairesi Müdürlüğü", "c": "KAYSERİ", "d": "Merkez"},
  {"n": "Felahiye Malmüdürlüğü", "c": "KAYSERİ", "d": "Felahiye"},
  {"n": "Gevher Nesibe Vergi Dairesi Müdürlüğü", "c": "KAYSERİ", "d": "Merkez"},
  {"n": "Hacılar Malmüdürlüğü", "c": "KAYSERİ", "d": "Merkez"},
  {"n": "Kaleönü Vergi Dairesi Müdürlüğü", "c": "KAYSERİ", "d": "Merkez"},
  {"n": "Kayseri İhtisas Vergi Dairesi Müdürlüğü", "c": "KAYSERİ", "d": "Merkez"},
  {"n": "Mimar Sinan Vergi Dairesi Müdürlüğü", "c": "KAYSERİ", "d": "Merkez"},
  {"n": "Pınarbaşı Vergi Dairesi Müdürlüğü", "c": "KAYSERİ", "d": "Pınarbaşı"},
  {"n": "Sarıoğlan Malmüdürlüğü", "c": "KAYSERİ", "d": "Sarıoğlan"},
  {"n": "Sarız Malmüdürlüğü", "c": "KAYSERİ", "d": "Sarız"},
  {"n": "Tomarza Malmüdürlüğü", "c": "KAYSERİ", "d": "Tomarza"},
  {"n": "Yahyalı Malmüdürlüğü", "c": "KAYSERİ", "d": "Yahyalı"},
  {"n": "Yeşilhisar Malmüdürlüğü", "c": "KAYSERİ", "d": "Yeşilhisar"},
  {"n": "Özvatan Malmüdürlüğü", "c": "KAYSERİ", "d": "Özvatan"},
  {"n": "İncesu Malmüdürlüğü", "c": "KAYSERİ", "d": "İncesu"},
  {"n": "Balışeyh Malmüdürlüğü", "c": "KIRIKKALE", "d": "Balışeyh"},
  {"n": "Delice Malmüdürlüğü", "c": "KIRIKKALE", "d": "Delice"},
  {"n": "Irmak Vergi Dairesi Müdürlüğü", "c": "KIRIKKALE", "d": "Merkez"},
  {"n": "Kaletepe Vergi Dairesi Müdürlüğü", "c": "KIRIKKALE", "d": "Merkez"},
  {"n": "Karakeçili Malmüdürlüğü", "c": "KIRIKKALE", "d": "Karakeçili"},
  {"n": "Keskin Malmüdürlüğü", "c": "KIRIKKALE", "d": "Keskin"},
  {"n": "Sulakyurt Malmüdürlüğü", "c": "KIRIKKALE", "d": "Sulakyurt"},
  {"n": "Çelebi Malmüdürlüğü", "c": "KIRIKKALE", "d": "Çelebi"},
  {"n": "Babaeski Vergi Dairesi Müdürlüğü", "c": "KIRKLARELİ", "d": "Babaeski"},
  {"n": "Demirköy Malmüdürlüğü", "c": "KIRKLARELİ", "d": "Demirköy"},
  {"n": "Kofçaz Malmüdürlüğü", "c": "KIRKLARELİ", "d": "Kofçaz"},
  {"n": "Kırklareli Vergi Dairesi Müdürlüğü", "c": "KIRKLARELİ", "d": "Merkez"},
  {"n": "Lüleburgaz Vergi Dairesi Müdürlüğü", "c": "KIRKLARELİ", "d": "Lüleburgaz"},
  {"n": "Pehlivanköy Malmüdürlüğü", "c": "KIRKLARELİ", "d": "Pehlivanköy"},
  {"n": "Pınarhisar Malmüdürlüğü", "c": "KIRKLARELİ", "d": "Pınarhisar"},
  {"n": "Vize Malmüdürlüğü", "c": "KIRKLARELİ", "d": "Vize"},
  {"n": "Akpınar Malmüdürlüğü", "c": "KIRŞEHİR", "d": "Akpınar"},
  {"n": "Akçakent Malmüdürlüğü", "c": "KIRŞEHİR", "d": "Akçakent"},
  {"n": "Boztepe Malmüdürlüğü", "c": "KIRŞEHİR", "d": "Boztepe"},
  {"n": "Kaman Vergi Dairesi Müdürlüğü", "c": "KIRŞEHİR", "d": "Kaman"},
  {"n": "Kırşehir Vergi Dairesi Müdürlüğü", "c": "KIRŞEHİR", "d": "Merkez"},
  {"n": "Mucur Malmüdürlüğü", "c": "KIRŞEHİR", "d": "Mucur"},
  {"n": "Çiçekdağı Malmüdürlüğü", "c": "KIRŞEHİR", "d": "Çiçekdağı"},
  {"n": "Acısu Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Alemdar Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Derince Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Gebze İhtisas Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Gölcük Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Kandıra Malmüdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Karamürsel Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Kocaeli İhtisas Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Körfez Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Tepecik Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Uluçınar Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "İlyasbey Vergi Dairesi Müdürlüğü", "c": "KOCAELİ", "d": "Merkez"},
  {"n": "Ahırlı Malmüdürlüğü", "c": "KONYA", "d": "Ahırlı"},
  {"n": "Akören Malmüdürlüğü", "c": "KONYA", "d": "Akören"},
  {"n": "Akşehir Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Akşehir"},
  {"n": "Alaaddin Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Merkez"},
  {"n": "Altınekin Malmüdürlüğü", "c": "KONYA", "d": "Altınekin"},
  {"n": "Beyşehir Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Beyşehir"},
  {"n": "Bozkır Malmüdürlüğü", "c": "KONYA", "d": "Bozkır"},
  {"n": "Cihanbeyli Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Cihanbeyli"},
  {"n": "Derbent Malmüdürlüğü", "c": "KONYA", "d": "Derbent"},
  {"n": "Derebucak Malmüdürlüğü", "c": "KONYA", "d": "Derebucak"},
  {"n": "Doğanhisar Malmüdürlüğü", "c": "KONYA", "d": "Doğanhisar"},
  {"n": "Emirgazi Malmüdürlüğü", "c": "KONYA", "d": "Emirgazi"},
  {"n": "Ereğli Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Ereğli"},
  {"n": "Güneysınır Malmüdürlüğü", "c": "KONYA", "d": "Güneysınır"},
  {"n": "Hadim Malmüdürlüğü", "c": "KONYA", "d": "Hadim"},
  {"n": "Halkapınar Malmüdürlüğü", "c": "KONYA", "d": "Halkapınar"},
  {"n": "Hüyük Malmüdürlüğü", "c": "KONYA", "d": "Hüyük"},
  {"n": "Ilgın Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Ilgın"},
  {"n": "Kadınhanı Malmüdürlüğü", "c": "KONYA", "d": "Kadınhanı"},
  {"n": "Karapınar Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Karapınar"},
  {"n": "Konya İhtisas Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Merkez"},
  {"n": "Kulu Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Kulu"},
  {"n": "Meram Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Merkez"},
  {"n": "Mevlana Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Merkez"},
  {"n": "Sarayönü Malmüdürlüğü", "c": "KONYA", "d": "Sarayönü"},
  {"n": "Selçuk Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Merkez"},
  {"n": "Seydişehir Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Seydişehir"},
  {"n": "Taşkent Malmüdürlüğü", "c": "KONYA", "d": "Taşkent"},
  {"n": "Tuzlukçu Malmüdürlüğü", "c": "KONYA", "d": "Tuzlukçu"},
  {"n": "Yalıhüyük Malmüdürlüğü", "c": "KONYA", "d": "Yalıhüyük"},
  {"n": "Yunak Malmüdürlüğü", "c": "KONYA", "d": "Yunak"},
  {"n": "Çeltik Malmüdürlüğü", "c": "KONYA", "d": "Çeltik"},
  {"n": "Çumra Vergi Dairesi Müdürlüğü", "c": "KONYA", "d": "Çumra"},
  {"n": "30 Ağustos Vergi Dairesi Müdürlüğü", "c": "KÜTAHYA", "d": "Merkez"},
  {"n": "Altıntaş Malmüdürlüğü", "c": "KÜTAHYA", "d": "Altıntaş"},
  {"n": "Aslanapa Malmüdürlüğü", "c": "KÜTAHYA", "d": "Aslanapa"},
  {"n": "Domaniç Malmüdürlüğü", "c": "KÜTAHYA", "d": "Domaniç"},
  {"n": "Dumlupınar Malmüdürlüğü", "c": "KÜTAHYA", "d": "Dumlupınar"},
  {"n": "Emet Vergi Dairesi Müdürlüğü", "c": "KÜTAHYA", "d": "Emet"},
  {"n": "Gediz Vergi Dairesi Müdürlüğü", "c": "KÜTAHYA", "d": "Gediz"},
  {"n": "Hisarcık Malmüdürlüğü", "c": "KÜTAHYA", "d": "Hisarcık"},
  {"n": "Pazarlar Malmüdürlüğü", "c": "KÜTAHYA", "d": "Pazarlar"},
  {"n": "Simav Vergi Dairesi Müdürlüğü", "c": "KÜTAHYA", "d": "Simav"},
  {"n": "Tavşanlı Vergi Dairesi Müdürlüğü", "c": "KÜTAHYA", "d": "Tavşanlı"},
  {"n": "Çavdarhisar Malmüdürlüğü", "c": "KÜTAHYA", "d": "Çavdarhisar"},
  {"n": "Çinili Vergi Dairesi Müdürlüğü", "c": "KÜTAHYA", "d": "Merkez"},
  {"n": "Şaphane Malmüdürlüğü", "c": "KÜTAHYA", "d": "Şaphane"},
  {"n": "Kilis Vergi Dairesi Müdürlüğü", "c": "KİLİS", "d": "Merkez"},
  {"n": "Akçadağ Malmüdürlüğü", "c": "MALATYA", "d": "Akçadağ"},
  {"n": "Arapgir Malmüdürlüğü", "c": "MALATYA", "d": "Arapgir"},
  {"n": "Arguvan Malmüdürlüğü", "c": "MALATYA", "d": "Arguvan"},
  {"n": "Battalgazi Malmüdürlüğü", "c": "MALATYA", "d": "Battalgazi"},
  {"n": "Beydağı Vergi Dairesi Müdürlüğü", "c": "MALATYA", "d": "Merkez"},
  {"n": "Darende Malmüdürlüğü", "c": "MALATYA", "d": "Darende"},
  {"n": "Doğanyol Malmüdürlüğü", "c": "MALATYA", "d": "Doğanyol"},
  {"n": "Doğanşehir Malmüdürlüğü", "c": "MALATYA", "d": "Doğanşehir"},
  {"n": "Fırat Vergi Dairesi Müdürlüğü", "c": "MALATYA", "d": "Merkez"},
  {"n": "Hekimhan Malmüdürlüğü", "c": "MALATYA", "d": "Hekimhan"},
  {"n": "Kale Malmüdürlüğü", "c": "MALATYA", "d": "Kale"},
  {"n": "Kuluncak Malmüdürlüğü", "c": "MALATYA", "d": "Kuluncak"},
  {"n": "Pütürge Malmüdürlüğü", "c": "MALATYA", "d": "Pütürge"},
  {"n": "Yazıhan Malmüdürlüğü", "c": "MALATYA", "d": "Yazıhan"},
  {"n": "Yeşilyurt Malmüdürlüğü", "c": "MALATYA", "d": "Yeşilyurt"},
  {"n": "Ahmetli Malmüdürlüğü", "c": "MANİSA", "d": "Ahmetli"},
  {"n": "Akhisar Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Akhisar"},
  {"n": "Alaşehir Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Alaşehir"},
  {"n": "Demirci Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Demirci"},
  {"n": "Gölmarmara Malmüdürlüğü", "c": "MANİSA", "d": "Gölmarmara"},
  {"n": "Gördes Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Gördes"},
  {"n": "Kula Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Kula"},
  {"n": "Köprübaşı Malmüdürlüğü", "c": "MANİSA", "d": "Köprübaşı"},
  {"n": "Kırkağaç Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Kırkağaç"},
  {"n": "Manisa İhtisas Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Merkez"},
  {"n": "Mesir Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Merkez"},
  {"n": "Salihli Adil Oral Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Salihli"},
  {"n": "Saruhanlı Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Saruhanlı"},
  {"n": "Sarıgöl Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Sarıgöl"},
  {"n": "Selendi Malmüdürlüğü", "c": "MANİSA", "d": "Selendi"},
  {"n": "Soma Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Soma"},
  {"n": "Turgutlu Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Turgutlu"},
  {"n": "Şehit Cihan Güneş Vergi Dairesi Müdürlüğü", "c": "MANİSA", "d": "Merkez"},
  {"n": "Dargeçit Malmüdürlüğü", "c": "MARDİN", "d": "Dargeçit"},
  {"n": "Derik Malmüdürlüğü", "c": "MARDİN", "d": "Derik"},
  {"n": "Kızıltepe Vergi Dairesi Müdürlüğü", "c": "MARDİN", "d": "Kızıltepe"},
  {"n": "Mardin Vergi Dairesi Müdürlüğü", "c": "MARDİN", "d": "Merkez"},
  {"n": "Mazıdağı Malmüdürlüğü", "c": "MARDİN", "d": "Mazıdağı"},
  {"n": "Midyat Malmüdürlüğü", "c": "MARDİN", "d": "Midyat"},
  {"n": "Nusaybin Vergi Dairesi Müdürlüğü", "c": "MARDİN", "d": "Nusaybin"},
  {"n": "Savur Malmüdürlüğü", "c": "MARDİN", "d": "Savur"},
  {"n": "Yeşilli Malmüdürlüğü", "c": "MARDİN", "d": "Yeşilli"},
  {"n": "Ömerli Malmüdürlüğü", "c": "MARDİN", "d": "Ömerli"},
  {"n": "Anamur Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Anamur"},
  {"n": "Aydıncık Malmüdürlüğü", "c": "MERSİN", "d": "Aydıncık"},
  {"n": "Bozyazı Malmüdürlüğü", "c": "MERSİN", "d": "Bozyazı"},
  {"n": "Erdemli Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Erdemli"},
  {"n": "Gülnar Malmüdürlüğü", "c": "MERSİN", "d": "Gülnar"},
  {"n": "Kızılmurat Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Tarsus"},
  {"n": "Liman Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Merkez"},
  {"n": "Mersin İhtisas Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Merkez"},
  {"n": "Mut Malmüdürlüğü", "c": "MERSİN", "d": "Mut"},
  {"n": "Silifke Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Silifke"},
  {"n": "Toros Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Merkez"},
  {"n": "Uray Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Merkez"},
  {"n": "Çamlıyayla Malmüdürlüğü", "c": "MERSİN", "d": "Çamlıyayla"},
  {"n": "İstiklâl Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Merkez"},
  {"n": "Şehitkerim Vergi Dairesi Müdürlüğü", "c": "MERSİN", "d": "Tarsus"},
  {"n": "Bodrum Vergi Dairesi Müdürlüğü", "c": "MUĞLA", "d": "Bodrum"},
  {"n": "Dalaman Malmüdürlüğü", "c": "MUĞLA", "d": "Dalaman"},
  {"n": "Datça Malmüdürlüğü", "c": "MUĞLA", "d": "Datça"},
  {"n": "Fethiye Vergi Dairesi Müdürlüğü", "c": "MUĞLA", "d": "Fethiye"},
  {"n": "Kavaklıdere Malmüdürlüğü", "c": "MUĞLA", "d": "Kavaklıdere"},
  {"n": "Köyceğiz Vergi Dairesi Müdürlüğü", "c": "MUĞLA", "d": "Köyceğiz"},
  {"n": "Marmaris Vergi Dairesi Müdürlüğü", "c": "MUĞLA", "d": "Marmaris"},
  {"n": "Milas Vergi Dairesi Müdürlüğü", "c": "MUĞLA", "d": "Milas"},
  {"n": "Muğla Vergi Dairesi Müdürlüğü", "c": "MUĞLA", "d": "Merkez"},
  {"n": "Ortaca Malmüdürlüğü", "c": "MUĞLA", "d": "Ortaca"},
  {"n": "Seydikemer Malmüdürlüğü", "c": "MUĞLA", "d": "Seydiemer"},
  {"n": "Ula Malmüdürlüğü", "c": "MUĞLA", "d": "Ula"},
  {"n": "Yatağan Vergi Dairesi Müdürlüğü", "c": "MUĞLA", "d": "Yatağan"},
  {"n": "Bulanık Malmüdürlüğü", "c": "MUŞ", "d": "Bulanık"},
  {"n": "Hasköy Malmüdürlüğü", "c": "MUŞ", "d": "Hasköy"},
  {"n": "Korkut Malmüdürlüğü", "c": "MUŞ", "d": "Korkut"},
  {"n": "Malazgirt Malmüdürlüğü", "c": "MUŞ", "d": "Malazgirt"},
  {"n": "Muş Vergi Dairesi Müdürlüğü", "c": "MUŞ", "d": "Merkez"},
  {"n": "Varto Malmüdürlüğü", "c": "MUŞ", "d": "Varto"},
  {"n": "Acıgöl Malmüdürlüğü", "c": "NEVŞEHİR", "d": "Acıgöl"},
  {"n": "Avanos Malmüdürlüğü", "c": "NEVŞEHİR", "d": "Avanos"},
  {"n": "Derinkuyu Malmüdürlüğü", "c": "NEVŞEHİR", "d": "Derinkuyu"},
  {"n": "Gülşehir Malmüdürlüğü", "c": "NEVŞEHİR", "d": "Gülşehir"},
  {"n": "Hacıbektaş Malmüdürlüğü", "c": "NEVŞEHİR", "d": "Hacıbektaş"},
  {"n": "Kozaklı Malmüdürlüğü", "c": "NEVŞEHİR", "d": "Kozaklı"},
  {"n": "Nevşehir Vergi Dairesi Müdürlüğü", "c": "NEVŞEHİR", "d": "Merkez"},
  {"n": "Ürgüp Malmüdürlüğü", "c": "NEVŞEHİR", "d": "Ürgüp"},
  {"n": "Altunhisar Malmüdürlüğü", "c": "NİĞDE", "d": "Altunhisar"},
  {"n": "Bor Vergi Dairesi Müdürlüğü", "c": "NİĞDE", "d": "Bor"},
  {"n": "Niğde Vergi Dairesi Müdürlüğü", "c": "NİĞDE", "d": "Merkez"},
  {"n": "Ulukışla Malmüdürlüğü", "c": "NİĞDE", "d": "Ulukışla"},
  {"n": "Çamardı Malmüdürlüğü", "c": "NİĞDE", "d": "Çamardı"},
  {"n": "Çiftlik Malmüdürlüğü", "c": "NİĞDE", "d": "Çiftlik"},
  {"n": "Akkuş Malmüdürlüğü", "c": "ORDU", "d": "Akkuş"},
  {"n": "Aybastı Malmüdürlüğü", "c": "ORDU", "d": "Aybastı"},
  {"n": "Boztepe Vergi Dairesi Müdürlüğü", "c": "ORDU", "d": "Merkez"},
  {"n": "Fatsa Vergi Dairesi Müdürlüğü", "c": "ORDU", "d": "Fatsa"},
  {"n": "Gölköy Malmüdürlüğü", "c": "ORDU", "d": "Gölköy"},
  {"n": "Gülyalı Malmüdürlüğü", "c": "ORDU", "d": "Gülyalı"},
  {"n": "Gürgentepe Malmüdürlüğü", "c": "ORDU", "d": "Gürgentepe"},
  {"n": "Kabadüz Malmüdürlüğü", "c": "ORDU", "d": "Kabadüz"},
  {"n": "Kabataş Malmüdürlüğü", "c": "ORDU", "d": "Kabataş"},
  {"n": "Korgan Malmüdürlüğü", "c": "ORDU", "d": "Korgan"},
  {"n": "Kumru Malmüdürlüğü", "c": "ORDU", "d": "Kumru"},
  {"n": "Köprübaşı Vergi Dairesi Müdürlüğü", "c": "ORDU", "d": "Merkez"},
  {"n": "Mesudiye Malmüdürlüğü", "c": "ORDU", "d": "Mesudiye"},
  {"n": "Perşembe Malmüdürlüğü", "c": "ORDU", "d": "Perşembe"},
  {"n": "Ulubey Malmüdürlüğü", "c": "ORDU", "d": "Ulubey"},
  {"n": "Çamaş Malmüdürlüğü", "c": "ORDU", "d": "Çamaş"},
  {"n": "Çatalpınar Malmüdürlüğü", "c": "ORDU", "d": "Çatalpınar"},
  {"n": "Çaybaşı Malmüdürlüğü", "c": "ORDU", "d": "Çaybaşı"},
  {"n": "Ünye Vergi Dairesi Müdürlüğü", "c": "ORDU", "d": "Ünye"},
  {"n": "İkizce Malmüdürlüğü", "c": "ORDU", "d": "İkizce"},
  {"n": "Bahçe Malmüdürlüğü", "c": "OSMANİYE", "d": "Bahçe"},
  {"n": "Düziçi Malmüdürlüğü", "c": "OSMANİYE", "d": "Düziçi"},
  {"n": "Hasanbeyli Malmüdürlüğü", "c": "OSMANİYE", "d": "Hasanbeyli"},
  {"n": "Kadirli Vergi Dairesi Müdürlüğü", "c": "OSMANİYE", "d": "Kadirli"},
  {"n": "Osmaniye Vergi Dairesi Müdürlüğü", "c": "OSMANİYE", "d": "Merkez"},
  {"n": "Sumbas Malmüdürlüğü", "c": "OSMANİYE", "d": "Sumbas"},
  {"n": "Toprakkale Malmüdürlüğü", "c": "OSMANİYE", "d": "Toprakkale"},
  {"n": "Ardeşen Vergi Dairesi Müdürlüğü", "c": "RİZE", "d": "Ardeşen"},
  {"n": "Derepazarı Malmüdürlüğü", "c": "RİZE", "d": "Derepazarı"},
  {"n": "Fındıklı Malmüdürlüğü", "c": "RİZE", "d": "Fındıklı"},
  {"n": "Güneysu Malmüdürlüğü", "c": "RİZE", "d": "Güneysu"},
  {"n": "Hemşin Malmüdürlüğü", "c": "RİZE", "d": "Hemşin"},
  {"n": "Kalkandere Malmüdürlüğü", "c": "RİZE", "d": "Kalkandere"},
  {"n": "Kaçkar Vergi Dairesi Müdürlüğü", "c": "RİZE", "d": "Merkez"},
  {"n": "Pazar Vergi Dairesi Müdürlüğü", "c": "RİZE", "d": "Pazar"},
  {"n": "Yeşilçay Vergi Dairesi Müdürlüğü", "c": "RİZE", "d": "Merkez"},
  {"n": "Çamlıhemşin Malmüdürlüğü", "c": "RİZE", "d": "Çamlıhemşin"},
  {"n": "Çayeli Vergi Dairesi Müdürlüğü", "c": "RİZE", "d": "Çayeli"},
  {"n": "İkizdere Malmüdürlüğü", "c": "RİZE", "d": "İkizdere"},
  {"n": "İyidere Malmüdürlüğü", "c": "RİZE", "d": "İyidere"},
  {"n": "Akyazı Vergi Dairesi Müdürlüğü", "c": "SAKARYA", "d": "Merkez"},
  {"n": "Ali Fuat Cebesoy Vergi Dairesi Müdürlüğü", "c": "SAKARYA", "d": "Merkez"},
  {"n": "Geyve Vergi Dairesi Müdürlüğü", "c": "SAKARYA", "d": "Geyve"},
  {"n": "Gümrükönü Vergi Dairesi Müdürlüğü", "c": "SAKARYA", "d": "Merkez"},
  {"n": "Hendek Vergi Dairesi Müdürlüğü", "c": "SAKARYA", "d": "Merkez"},
  {"n": "Karapürçek Malmüdürlüğü", "c": "SAKARYA", "d": "Merkez"},
  {"n": "Karasu Vergi Dairesi Müdürlüğü", "c": "SAKARYA", "d": "Karasu"},
  {"n": "Kaynarca Malmüdürlüğü", "c": "SAKARYA", "d": "Kaynarca"},
  {"n": "Kocaali Malmüdürlüğü", "c": "SAKARYA", "d": "Kocaali"},
  {"n": "Pamukova Malmüdürlüğü", "c": "SAKARYA", "d": "Pamukova"},
  {"n": "Sakarya İhtisas Vergi Dairesi Müdürlüğü", "c": "SAKARYA", "d": "Merkez"},
  {"n": "Sapanca Vergi Dairesi Müdürlüğü", "c": "SAKARYA", "d": "Merkez"},
  {"n": "Taraklı Malmüdürlüğü", "c": "SAKARYA", "d": "Taraklı"},
  {"n": "19 Mayıs Vergi Dairesi Müdürlüğü", "c": "SAMSUN", "d": "Merkez"},
  {"n": "Alaçam Malmüdürlüğü", "c": "SAMSUN", "d": "Alaçam"},
  {"n": "Asarcık Malmüdürlüğü", "c": "SAMSUN", "d": "Asarcık"},
  {"n": "Ayvacık Malmüdürlüğü", "c": "SAMSUN", "d": "Ayvacık"},
  {"n": "Bafra Vergi Dairesi Müdürlüğü", "c": "SAMSUN", "d": "Bafra"},
  {"n": "Gaziler Vergi Dairesi Müdürlüğü", "c": "SAMSUN", "d": "Merkez"},
  {"n": "Havza Vergi Dairesi Müdürlüğü", "c": "SAMSUN", "d": "Havza"},
  {"n": "Kavak Malmüdürlüğü", "c": "SAMSUN", "d": "Kavak"},
  {"n": "Ladik Malmüdürlüğü", "c": "SAMSUN", "d": "Ladik"},
  {"n": "Ondokuz Mayıs Malmüdürlüğü", "c": "SAMSUN", "d": "Ondokuz Mayıs"},
  {"n": "Salıpazarı Malmüdürlüğü", "c": "SAMSUN", "d": "Salıpazarı"},
  {"n": "Tekkeköy Malmüdürlüğü", "c": "SAMSUN", "d": "Merkez"},
  {"n": "Terme Vergi Dairesi Müdürlüğü", "c": "SAMSUN", "d": "Terme"},
  {"n": "Vezirköprü Malmüdürlüğü", "c": "SAMSUN", "d": "Vezirköprü"},
  {"n": "Yakakent Malmüdürlüğü", "c": "SAMSUN", "d": "Yakakent"},
  {"n": "Zafer Vergi Dairesi Müdürlüğü", "c": "SAMSUN", "d": "Merkez"},
  {"n": "Çarşamba Vergi Dairesi Müdürlüğü", "c": "SAMSUN", "d": "Çarşamba"},
  {"n": "Ayancık Malmüdürlüğü", "c": "SİNOP", "d": "Ayancık"},
  {"n": "Boyabat Vergi Dairesi Müdürlüğü", "c": "SİNOP", "d": "Boyabat"},
  {"n": "Dikmen Malmüdürlüğü", "c": "SİNOP", "d": "Dikmen"},
  {"n": "Durağan Malmüdürlüğü", "c": "SİNOP", "d": "Durağan"},
  {"n": "Erfelek Malmüdürlüğü", "c": "SİNOP", "d": "Erfelek"},
  {"n": "Gerze Malmüdürlüğü", "c": "SİNOP", "d": "Gerze"},
  {"n": "Saraydüzü Malmüdürlüğü", "c": "SİNOP", "d": "Saraydüzü"},
  {"n": "Sinop Vergi Dairesi Müdürlüğü", "c": "SİNOP", "d": "Merkez"},
  {"n": "Türkeli Malmüdürlüğü", "c": "SİNOP", "d": "Türkeli"},
  {"n": "Akıncılar Malmüdürlüğü", "c": "SİVAS", "d": "Akıncılar"},
  {"n": "Altınyayla Malmüdürlüğü", "c": "SİVAS", "d": "Altınyayla"},
  {"n": "Divriği Malmüdürlüğü", "c": "SİVAS", "d": "Divriği"},
  {"n": "Doğanşar Malmüdürlüğü", "c": "SİVAS", "d": "Doğanşar"},
  {"n": "Gemerek Malmüdürlüğü", "c": "SİVAS", "d": "Gemerek"},
  {"n": "Gölova Malmüdürlüğü", "c": "SİVAS", "d": "Gölova"},
  {"n": "Gürün Malmüdürlüğü", "c": "SİVAS", "d": "Gürün"},
  {"n": "Hafik Malmüdürlüğü", "c": "SİVAS", "d": "Hafik"},
  {"n": "Kale Vergi Dairesi Müdürlüğü", "c": "SİVAS", "d": "Merkez"},
  {"n": "Kangal Malmüdürlüğü", "c": "SİVAS", "d": "Kangal"},
  {"n": "Koyulhisar Malmüdürlüğü", "c": "SİVAS", "d": "Koyulhisar"},
  {"n": "Site Vergi Dairesi Müdürlüğü", "c": "SİVAS", "d": "Merkez"},
  {"n": "Suşehri Malmüdürlüğü", "c": "SİVAS", "d": "Suşehri"},
  {"n": "Ulaş Malmüdürlüğü", "c": "SİVAS", "d": "Ulaş"},
  {"n": "Yıldızeli Malmüdürlüğü", "c": "SİVAS", "d": "Yıldızeli"},
  {"n": "Zara Malmüdürlüğü", "c": "SİVAS", "d": "Zara"},
  {"n": "İmranlı Malmüdürlüğü", "c": "SİVAS", "d": "İmranlı"},
  {"n": "Şarkışla Vergi Dairesi Müdürlüğü", "c": "SİVAS", "d": "Şarkışla"},
  {"n": "Baykan Malmüdürlüğü", "c": "SİİRT", "d": "Baykan"},
  {"n": "Eruh Malmüdürlüğü", "c": "SİİRT", "d": "Eruh"},
  {"n": "Kurtalan Malmüdürlüğü", "c": "SİİRT", "d": "Kurtalan"},
  {"n": "Pervari Malmüdürlüğü", "c": "SİİRT", "d": "Pervari"},
  {"n": "Siirt Vergi Dairesi Müdürlüğü", "c": "SİİRT", "d": "Merkez"},
  {"n": "Şirvan Malmüdürlüğü", "c": "SİİRT", "d": "Şirvan"},
  {"n": "Hayrabolu Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Hayrabolu"},
  {"n": "Kapaklı Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Kapaklı"},
  {"n": "Malkara Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Malkara"},
  {"n": "Marmaraereğlisi Malmüdürlüğü", "c": "TEKİRDAĞ", "d": "Marmaraereğlisi"},
  {"n": "Muratlı Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Muratlı"},
  {"n": "Namık Kemal Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Merkez"},
  {"n": "Saray Malmüdürlüğü", "c": "TEKİRDAĞ", "d": "Saray"},
  {"n": "Süleymanpaşa Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Merkez"},
  {"n": "Çerkezköy Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Çerkezköy"},
  {"n": "Çorlu Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Çorlu"},
  {"n": "Çorlu İhtisas Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Çorlu"},
  {"n": "Şarköy Vergi Dairesi Müdürlüğü", "c": "TEKİRDAĞ", "d": "Şarköy"},
  {"n": "Almus Malmüdürlüğü", "c": "TOKAT", "d": "Almus"},
  {"n": "Artova Malmüdürlüğü", "c": "TOKAT", "d": "Artova"},
  {"n": "Başçiftlik Malmüdürlüğü", "c": "TOKAT", "d": "Başçiftlik"},
  {"n": "Erbaa Vergi Dairesi Müdürlüğü", "c": "TOKAT", "d": "Erbaa"},
  {"n": "Niksar Vergi Dairesi Müdürlüğü", "c": "TOKAT", "d": "Niksar"},
  {"n": "Pazar Malmüdürlüğü", "c": "TOKAT", "d": "Pazar"},
  {"n": "Reşadiye Malmüdürlüğü", "c": "TOKAT", "d": "Reşadiye"},
  {"n": "Sulusaray Malmüdürlüğü", "c": "TOKAT", "d": "Sulusaray"},
  {"n": "Tokat Vergi Dairesi Müdürlüğü", "c": "TOKAT", "d": "Merkez"},
  {"n": "Turhal Vergi Dairesi Müdürlüğü", "c": "TOKAT", "d": "Turhal"},
  {"n": "Yeşilyurt Malmüdürlüğü", "c": "TOKAT", "d": "Yeşilyurt"},
  {"n": "Zile Vergi Dairesi Müdürlüğü", "c": "TOKAT", "d": "Zile"},
  {"n": "Akçaabat Vergi Dairesi Müdürlüğü", "c": "TRABZON", "d": "Akçaabat"},
  {"n": "Araklı Malmüdürlüğü", "c": "TRABZON", "d": "Araklı"},
  {"n": "Arsin Malmüdürlüğü", "c": "TRABZON", "d": "Arsin"},
  {"n": "Beşikdüzü Malmüdürlüğü", "c": "TRABZON", "d": "Beşikdüzü"},
  {"n": "Dernekpazarı Malmüdürlüğü", "c": "TRABZON", "d": "Dernekpazarı"},
  {"n": "Düzköy Malmüdürlüğü", "c": "TRABZON", "d": "Düzköy"},
  {"n": "Hayrat Malmüdürlüğü", "c": "TRABZON", "d": "Hayrat"},
  {"n": "Hızırbey Vergi Dairesi Müdürlüğü", "c": "TRABZON", "d": "Merkez"},
  {"n": "Karadeniz Vergi Dairesi Müdürlüğü", "c": "TRABZON", "d": "Merkez"},
  {"n": "Köprübaşı Malmüdürlüğü", "c": "TRABZON", "d": "Köprübaşı"},
  {"n": "Maçka Malmüdürlüğü", "c": "TRABZON", "d": "Maçka"},
  {"n": "Of Vergi Dairesi Müdürlüğü", "c": "TRABZON", "d": "Of"},
  {"n": "Sürmene Malmüdürlüğü", "c": "TRABZON", "d": "Sürmene"},
  {"n": "Tonya Malmüdürlüğü", "c": "TRABZON", "d": "Tonya"},
  {"n": "Vakfıkebir Vergi Dairesi Müdürlüğü", "c": "TRABZON", "d": "Vakfıkebir"},
  {"n": "Yomra Malmüdürlüğü", "c": "TRABZON", "d": "Yomra"},
  {"n": "Çarşıbaşı Malmüdürlüğü", "c": "TRABZON", "d": "Çarşıbaşı"},
  {"n": "Çaykara Malmüdürlüğü", "c": "TRABZON", "d": "Çaykara"},
  {"n": "Şalpazarı Malmüdürlüğü", "c": "TRABZON", "d": "Şalpazarı"},
  {"n": "Hozat Malmüdürlüğü", "c": "TUNCELİ", "d": "Hozat"},
  {"n": "Mazgirt Malmüdürlüğü", "c": "TUNCELİ", "d": "Mazgirt"},
  {"n": "Nazimiye Malmüdürlüğü", "c": "TUNCELİ", "d": "Nazimiye"},
  {"n": "Ovacık Malmüdürlüğü", "c": "TUNCELİ", "d": "Ovacık"},
  {"n": "Pertek Malmüdürlüğü", "c": "TUNCELİ", "d": "Pertek"},
  {"n": "Pülümür Malmüdürlüğü", "c": "TUNCELİ", "d": "Pülümür"},
  {"n": "Tunceli Vergi Dairesi Müdürlüğü", "c": "TUNCELİ", "d": "Merkez"},
  {"n": "Çemişgezek Malmüdürlüğü", "c": "TUNCELİ", "d": "Çemişgezek"},
  {"n": "Banaz Vergi Dairesi Müdürlüğü", "c": "UŞAK", "d": "Banaz"},
  {"n": "Eşme Vergi Dairesi Müdürlüğü", "c": "UŞAK", "d": "Eşme"},
  {"n": "Karahallı Malmüdürlüğü", "c": "UŞAK", "d": "Karahallı"},
  {"n": "Sivaslı Malmüdürlüğü", "c": "UŞAK", "d": "Sivaslı"},
  {"n": "Ulubey Malmüdürlüğü", "c": "UŞAK", "d": "Ulubey"},
  {"n": "Uşak Vergi Dairesi Müdürlüğü", "c": "UŞAK", "d": "Merkez"},
  {"n": "Bahçesaray Malmüdürlüğü", "c": "VAN", "d": "Bahçesaray"},
  {"n": "Başkale Malmüdürlüğü", "c": "VAN", "d": "Başkale"},
  {"n": "Edremit Malmüdürlüğü", "c": "VAN", "d": "Edremit"},
  {"n": "Erciş Vergi Dairesi Müdürlüğü", "c": "VAN", "d": "Erciş"},
  {"n": "Gevaş Malmüdürlüğü", "c": "VAN", "d": "Gevaş"},
  {"n": "Gürpınar Malmüdürlüğü", "c": "VAN", "d": "Gürpınar"},
  {"n": "Muradiye Malmüdürlüğü", "c": "VAN", "d": "Muradiye"},
  {"n": "Saray Malmüdürlüğü", "c": "VAN", "d": "Saray"},
  {"n": "Van Vergi Dairesi Müdürlüğü", "c": "VAN", "d": "Merkez"},
  {"n": "Çaldıran Malmüdürlüğü", "c": "VAN", "d": "Çaldıran"},
  {"n": "Çatak Malmüdürlüğü", "c": "VAN", "d": "Çatak"},
  {"n": "Özalp Malmüdürlüğü", "c": "VAN", "d": "Özalp"},
  {"n": "Altınova Malmüdürlüğü", "c": "YALOVA", "d": "Altınova"},
  {"n": "Armutlu Malmüdürlüğü", "c": "YALOVA", "d": "Armutlu"},
  {"n": "Yalova Vergi Dairesi Müdürlüğü", "c": "YALOVA", "d": "Merkez"},
  {"n": "Çınarcık Malmüdürlüğü", "c": "YALOVA", "d": "Çınarcık"},
  {"n": "Akdağmadeni Malmüdürlüğü", "c": "YOZGAT", "d": "Akdağmadeni"},
  {"n": "Aydıncık Malmüdürlüğü", "c": "YOZGAT", "d": "Aydıncık"},
  {"n": "Boğazlıyan Vergi Dairesi Müdürlüğü", "c": "YOZGAT", "d": "Boğazlıyan"},
  {"n": "Kadışehri Malmüdürlüğü", "c": "YOZGAT", "d": "Kadışehri"},
  {"n": "Saraykent Malmüdürlüğü", "c": "YOZGAT", "d": "Saraykent"},
  {"n": "Sarıkaya Malmüdürlüğü", "c": "YOZGAT", "d": "Sarıkaya"},
  {"n": "Sorgun Vergi Dairesi Müdürlüğü", "c": "YOZGAT", "d": "Sorgun"},
  {"n": "Yenifakılı Malmüdürlüğü", "c": "YOZGAT", "d": "Yenifakılı"},
  {"n": "Yerköy Vergi Dairesi Müdürlüğü", "c": "YOZGAT", "d": "Yerköy"},
  {"n": "Yozgat Vergi Dairesi Müdürlüğü", "c": "YOZGAT", "d": "Merkez"},
  {"n": "Çandır Malmüdürlüğü", "c": "YOZGAT", "d": "Çandır"},
  {"n": "Çayıralan Malmüdürlüğü", "c": "YOZGAT", "d": "Çayıralan"},
  {"n": "Çekerek Malmüdürlüğü", "c": "YOZGAT", "d": "Çekerek"},
  {"n": "Şefaatli Malmüdürlüğü", "c": "YOZGAT", "d": "Şefaatli"},
  {"n": "Alaplı Malmüdürlüğü", "c": "ZONGULDAK", "d": "Alaplı"},
  {"n": "Devrek Vergi Dairesi Müdürlüğü", "c": "ZONGULDAK", "d": "Devrek"},
  {"n": "Ereğli Vergi Dairesi Müdürlüğü", "c": "ZONGULDAK", "d": "Ereğli"},
  {"n": "Gökçebey Malmüdürlüğü", "c": "ZONGULDAK", "d": "Gökçebey"},
  {"n": "Kara Elmas Vergi Dairesi Müdürlüğü", "c": "ZONGULDAK", "d": "Merkez"},
  {"n": "Uzunmehmet Vergi Dairesi Müdürlüğü", "c": "ZONGULDAK", "d": "Merkez"},
  {"n": "Çaycuma Vergi Dairesi Müdürlüğü", "c": "ZONGULDAK", "d": "Çaycuma"},
  {"n": "Ayvacık Malmüdürlüğü", "c": "ÇANAKKALE", "d": "Ayvacık"},
  {"n": "Bayramiç Malmüdürlüğü", "c": "ÇANAKKALE", "d": "Bayramiç"},
  {"n": "Biga Vergi Dairesi Müdürlüğü", "c": "ÇANAKKALE", "d": "Biga"},
  {"n": "Bozcaada Malmüdürlüğü", "c": "ÇANAKKALE", "d": "Bozcaada"},
  {"n": "Eceabat Malmüdürlüğü", "c": "ÇANAKKALE", "d": "Eceabat"},
  {"n": "Ezine Malmüdürlüğü", "c": "ÇANAKKALE", "d": "Ezine"},
  {"n": "Gelibolu Vergi Dairesi Müdürlüğü", "c": "ÇANAKKALE", "d": "Gelibolu"},
  {"n": "Gökçeada Malmüdürlüğü", "c": "ÇANAKKALE", "d": "Gökçeada"},
  {"n": "Lapseki Malmüdürlüğü", "c": "ÇANAKKALE", "d": "Lapseki"},
  {"n": "Yenice Malmüdürlüğü", "c": "ÇANAKKALE", "d": "Yenice"},
  {"n": "Çan Vergi Dairesi Müdürlüğü", "c": "ÇANAKKALE", "d": "Çan"},
  {"n": "Çanakkale Vergi Dairesi Müdürlüğü", "c": "ÇANAKKALE", "d": "Merkez"},
  {"n": "Atkaracalar Malmüdürlüğü", "c": "ÇANKIRI", "d": "Atkaracalar"},
  {"n": "Bayramören Malmüdürlüğü", "c": "ÇANKIRI", "d": "Bayramören"},
  {"n": "Eldivan Malmüdürlüğü", "c": "ÇANKIRI", "d": "Eldivan"},
  {"n": "Ilgaz Malmüdürlüğü", "c": "ÇANKIRI", "d": "Ilgaz"},
  {"n": "Korgun Malmüdürlüğü", "c": "ÇANKIRI", "d": "Korgun"},
  {"n": "Kurşunlu Malmüdürlüğü", "c": "ÇANKIRI", "d": "Kurşunlu"},
  {"n": "Kızılırmak Malmüdürlüğü", "c": "ÇANKIRI", "d": "Kızılırmak"},
  {"n": "Orta Malmüdürlüğü", "c": "ÇANKIRI", "d": "Orta"},
  {"n": "Yapraklı Malmüdürlüğü", "c": "ÇANKIRI", "d": "Yapraklı"},
  {"n": "Çankırı Vergi Dairesi Müdürlüğü", "c": "ÇANKIRI", "d": "Merkez"},
  {"n": "Çerkeş Malmüdürlüğü", "c": "ÇANKIRI", "d": "Çerkeş"},
  {"n": "Şabanözü Malmüdürlüğü", "c": "ÇANKIRI", "d": "Şabanözü"},
  {"n": "Alaca Malmüdürlüğü", "c": "ÇORUM", "d": "Alaca"},
  {"n": "Bayat Malmüdürlüğü", "c": "ÇORUM", "d": "Bayat"},
  {"n": "Boğazkale Malmüdürlüğü", "c": "ÇORUM", "d": "Boğazkale"},
  {"n": "Dodurga Malmüdürlüğü", "c": "ÇORUM", "d": "Dodurga"},
  {"n": "Kargı Malmüdürlüğü", "c": "ÇORUM", "d": "Kargı"},
  {"n": "Laçin Malmüdürlüğü", "c": "ÇORUM", "d": "Laçin"},
  {"n": "Mecitözü Malmüdürlüğü", "c": "ÇORUM", "d": "Mecitözü"},
  {"n": "Ortaköy Malmüdürlüğü", "c": "ÇORUM", "d": "Ortaköy"},
  {"n": "Osmancık Malmüdürlüğü", "c": "ÇORUM", "d": "Osmancık"},
  {"n": "Oğuzlar Malmüdürlüğü", "c": "ÇORUM", "d": "Oğuzlar"},
  {"n": "Sungurlu Vergi Dairesi Müdürlüğü", "c": "ÇORUM", "d": "Sungurlu"},
  {"n": "Uğurludağ Malmüdürlüğü", "c": "ÇORUM", "d": "Uğurludağ"},
  {"n": "Çorum Vergi Dairesi Müdürlüğü", "c": "ÇORUM", "d": "Merkez"},
  {"n": "İskilip Malmüdürlüğü", "c": "ÇORUM", "d": "İskilip"},
  {"n": "Adalar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Alemdağ Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Anadolu Kurumlar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Atışalanı Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Avcılar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Bakırköy Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Bayrampaşa Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Beyazıt Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Beykoz Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Beylikdüzü Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Beyoğlu Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Beşiktaş Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Boğaziçi Kurumlar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Büyük Mükellefler Vergi Dairesi Başkanlığı (*)", "c": "İSTANBUL", "d": "Merkez Başkanlık"},
  {"n": "Büyükçekmece Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Davutpaşa Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Erenköy Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Esenler Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Esenyurt Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Fatih Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Gaziosmanpaşa Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Göztepe Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Güneşli Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Güngören Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Haliç İhtisas Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Halkalı Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Hisar Veraset ve Harçlar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Hocapaşa Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Kadıköy Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Kartal Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Kasımpaşa Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Kağıthane Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Kocamustafapaşa Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Kocasinan Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Kozyatağı Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Küçükköy Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Küçükyalı Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Küçükçekmece Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Marmara Kurumlar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Maslak Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Mecidiyeköy Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Merter Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Nakil Vasıtaları Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Pendik Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Rıhtım Veraset ve Harçlar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Sarıgazi Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Sarıyer Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Silivri Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Sultanbeyli Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Tuna Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Tuzla Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Vatan İhtisas Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Yakacık Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Yeditepe Veraset ve Harçlar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Yenibosna Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Yenikapı Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Zeytinburnu Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Zincirlikuyu Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Çamlıca İhtisas Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Ümraniye Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Üsküdar Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "İkitelli Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Şile Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "Şişli Vergi Dairesi Müdürlüğü", "c": "İSTANBUL", "d": "Merkez"},
  {"n": "9 Eylül Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Aliağa Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Balçova Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Bayındır Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Bayındır"},
  {"n": "Belkahve Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Bergama Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Bergama"},
  {"n": "Beydağ Malmüdürlüğü", "c": "İZMİR", "d": "Beydağ"},
  {"n": "Bornova Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Dikili Malmüdürlüğü", "c": "İZMİR", "d": "Dikili"},
  {"n": "Ege Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Foça Malmüdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Gaziemir Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Hasan Tahsin Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Kadifekale Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Karaburun Malmüdürlüğü", "c": "İZMİR", "d": "Karaburun"},
  {"n": "Karşıyaka Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Kemalpaşa Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Kemeraltı Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Kiraz Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Kiraz"},
  {"n": "Konak Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Kordon Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Kınık Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Kınık"},
  {"n": "Menderes Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Menemen Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Seferihisar Malmüdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Selçuk Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Selçuk"},
  {"n": "Taşıtlar Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Tire Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Tire"},
  {"n": "Torbalı Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Urla Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Yamanlar Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Çakabey İhtisas Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Çeşme Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Çeşme"},
  {"n": "Çiğli Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Ödemiş Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Ödemiş"},
  {"n": "İzmir İhtisas Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Şirinyer Vergi Dairesi Müdürlüğü", "c": "İZMİR", "d": "Merkez"},
  {"n": "Akçakale Malmüdürlüğü", "c": "ŞANLIURFA", "d": "Akçakale"},
  {"n": "Birecik Vergi Dairesi Müdürlüğü", "c": "ŞANLIURFA", "d": "Birecik"},
  {"n": "Bozova Malmüdürlüğü", "c": "ŞANLIURFA", "d": "Bozova"},
  {"n": "Ceylanpınar Malmüdürlüğü", "c": "ŞANLIURFA", "d": "Ceylanpınar"},
  {"n": "Göbeklitepe Vergi Dairesi Müdürlüğü", "c": "ŞANLIURFA", "d": "Merkez"},
  {"n": "Halfeti Malmüdürlüğü", "c": "ŞANLIURFA", "d": "Halfeti"},
  {"n": "Harran Malmüdürlüğü", "c": "ŞANLIURFA", "d": "Harran"},
  {"n": "Hilvan Malmüdürlüğü", "c": "ŞANLIURFA", "d": "Hilvan"},
  {"n": "Siverek Vergi Dairesi Müdürlüğü", "c": "ŞANLIURFA", "d": "Siverek"},
  {"n": "Suruç Vergi Dairesi Müdürlüğü", "c": "ŞANLIURFA", "d": "Suruç"},
  {"n": "Topçu Meydanı Vergi Dairesi Müdürlüğü", "c": "ŞANLIURFA", "d": "Merkez"},
  {"n": "Viranşehir Vergi Dairesi Müdürlüğü", "c": "ŞANLIURFA", "d": "Viranşehir"},
  {"n": "Şehitlik Vergi Dairesi Müdürlüğü", "c": "ŞANLIURFA", "d": "Merkez"},
  {"n": "Beytüşşebap Malmüdürlüğü", "c": "ŞIRNAK", "d": "Beytüşşebap"},
  {"n": "Cizre Vergi Dairesi Müdürlüğü", "c": "ŞIRNAK", "d": "Cizre"},
  {"n": "Güçlükonak Malmüdürlüğü", "c": "ŞIRNAK", "d": "Güçlükonak"},
  {"n": "Silopi Vergi Dairesi Müdürlüğü", "c": "ŞIRNAK", "d": "Silopi"},
  {"n": "Uludere Malmüdürlüğü", "c": "ŞIRNAK", "d": "Uludere"},
  {"n": "İdil Malmüdürlüğü", "c": "ŞIRNAK", "d": "İdil"},
  {"n": "Şırnak Vergi Dairesi Müdürlüğü", "c": "ŞIRNAK", "d": "Merkez"},
];

export default TAX_OFFICES;

// Serbest/eski kayıtlardaki vergi dairesi adını (ör. "SİLİVRİ", "BÜYÜKÇEKMECE VD.") resmi liste adıyla eşleştirir.
const _STOP = new Set(["VERGİ", "DAİRESİ", "MÜDÜRLÜĞÜ", "VD", "V", "D", "MAL", "MÜD", "BAŞKANLIĞI", "VERGI", "DAIRESI", "MUDURLUGU"]);
const _norm = (s) => String(s || "").toLocaleUpperCase("tr").replace(/[^0-9A-ZÇĞİÖŞÜ ]/g, " ").split(/\s+/).filter((t) => t && !_STOP.has(t)).join(" ").trim();
const _index = (() => {
  const m = new Map();
  for (const o of TAX_OFFICES) {
    const k = _norm(o.n);
    if (!k) continue;
    if (!m.has(k)) m.set(k, []);
    m.get(k).push(o);
  }
  return m;
})();

// raw'ı resmi daire adına çevirir; emin değilse raw'ı aynen döndürür (yanlış eşleştirme yapmaz).
export const findTaxOffice = (raw, city) => {
  const n = _norm(raw);
  if (!n) return raw || "";
  const cands = _index.get(n);
  if (!cands) return raw || "";
  if (cands.length === 1) return cands[0].n;
  if (city) {
    const cn = _norm(city);
    const byCity = cands.find((o) => _norm(o.c) === cn);
    if (byCity) return byCity.n;
  }
  return cands[0].n;
};
